export default __webpack_public_path__ + "static/media/coffee.9cf8c0b1.jpg";